export class Stamptestfile {
  id: number;
  name: string;
  length: string;
  base64Data: string;
  active: number;
}
